import { find, mergeLeft, propEq, startsWith } from 'ramda';

export const disableCache = src => {
  // don't add query parameter if we have a base64 image
  return startsWith('data:', src) ? src : `${src}?cache=${Date.now()}`;
};

export const mergeAnswers = (answers, statsAnswers) => {
  return answers.map(a => {
    const sa = find(propEq('answerId', a.answerId))(statsAnswers);
    return mergeLeft(sa, a);
  })
}